import React, { useState, useEffect } from 'react';
import { Typography, Button, Divider } from '@material-ui/core'
import { Elements, CardElement, ElementsConsumer } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import Review from './Review'
import useStyle from './Checkout/style'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import icon from '../../assets/Bni.png';
import axios from 'axios';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)

const PaymentForm = ({ checkoutToken, shippingData, backStep, onCaptureCheckout, nextStep, timeout, refreshCart}) => {
    /*const[namaDepan, setnamaDepan] = useState('');
    const[namaBelakang, setnamaBelakang] = useState('');
    const[alamat, setAlamat] = useState('');
    const[email, setEmail] = useState('');
    const[kota, setKota] = useState('');
    const[kodePos, setkodePos] = useState('');
    const[provinsi, setProvinsi] = useState('');*/
    const[formData, setFormData] = useState('');
    const[image, setImage] = useState('');
    const[jumlah, setJumlah] = useState([]);
    const[product, setProduct] = useState([]);



  /*const handleSubmit = async (event, elements, stripe) => {
    // Not refresh after click button
    event.preventDefault();
    if(!stripe || !elements) return;
    const cardElement = elements.getElement(CardElement);
    
    // PaymentMethod
    const { error, paymentMethod } = await stripe.createPaymentMethod({ type: 'card', card: cardElement });

    if(error) {
        console.log(error)
    } else {
        const orderData = {
            line_items: checkoutToken.live.line_items,
            customer: {
              firstname: shippingData.firstName, 
              lastname: shippingData.lastName, 
              email: shippingData.email},
            shipping: {
                name: 'Primary', 
                street: shippingData.address1, 
                town_city: shippingData.city,
                county_state: shippingData.shippingSubdivision,
                postal_zip_code: shippingData.zip,
                country: shippingData.shippingCountry
            },
            fulfillment: {shipping_method: shippingData.shippingOption},
            payment: {
                gateway: 'stripe',
                stripe: {
                    payment_method_id: paymentMethod.id
                }
            }
        }
        onCaptureCheckout(checkoutToken.id, orderData);
        timeout();
        // console.log(orderData)
        nextStep();
    }

}*/

useEffect(() => {
    setFormData(new FormData())
}, []);

const ChangeImage = (e) => {
    const file = e.target.files[0]
    setImage(file)
}

const handleSubmit = (e) => {
    e.preventDefault();
    formData.set('namaDepan', shippingData.firstName);
    formData.set('namaBelakang', shippingData.lastName);
    formData.set('alamat', shippingData.address1);
    formData.set('email', shippingData.email);
    formData.set('kota', shippingData.city);
    formData.set('kodePos', shippingData.zip);
    formData.set('provinsi', shippingData.shippingSubdivision);
    formData.set('total', checkoutToken.live.subtotal.formatted_with_symbol);
    formData.set('product', namaProduct);
    formData.set('jumlah', jumlahProduct);
    formData.set('status', 0);
    formData.append('image', image);
    
    axios.post('https://backendserverr.herokuapp.com/createimage', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    
    .then(res => {
        console.log('result', res)
        timeout();
        nextStep();
        refreshCart();
    })
}

const namaProduct = checkoutToken.live.line_items.map(Product => {
    return Product.name
})
console.log(namaProduct)

const jumlahProduct = checkoutToken.live.line_items.map(Product => {
    return Product.quantity
})
console.log(jumlahProduct)


    const classes = useStyle()

    return (
        <>
            <Review checkoutToken={checkoutToken}/>
            <Divider />
            <Typography variant="h6" gutterBottom style={{margin: '20px 5px 0 0'}}>Metode Pembayaran</Typography>
            <Elements stripe={stripePromise}>
                <ElementsConsumer>
                    {() => (
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <img src={icon} alt="banner" height="35px" style={{margin: '-20px 0px'}}/>
                            <h3>0410486550 (Al Fajri)</h3>
                            <label>Upload Bukti Pembayaran</label>
                            <div style={{margin: '20px 5px'}}>
                            <input type="file" onChange={ChangeImage}/>
                            </div>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <Button variant="outlined" onClick={backStep}><KeyboardArrowLeftIcon/>Kembali</Button>
                                <Button onClick={handleSubmit} className={classes.next} disabled={!image}>
                                    Bayar {checkoutToken.live.subtotal.formatted_with_symbol}
                                </Button>
                            </div>
                        </form>
                    )}
                </ElementsConsumer>
            </Elements>
        </>
    )
}

export default PaymentForm
